
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import Map from '~/components/UI/Map'
import productData from '@/data/products.json'
export default {

  name: 'CourseInfo',
  components: {
    Map,
  },

  props: {
    city: {
      type: String,
      default:''
    },
    display: {
      type: String,
      default:'all'
    },
    nearby: {
      type: String,
      default: 'auto'
    }
  },
  data() {
    return {
      classrooms: [],
      locations: [],
      toggleView: this.$props.display,
      allLocations: [],
      zoom: 7,
      noOfRows: 5,
      cities: [
        { long: 0.8775, lat: 51.148, country: "EN", town: "Ashford" },
        { long: -1.8986, lat: 52.4862, country: "EN", town: "Birmingham" },
        { long: -1.8808, lat: 50.7192, country: "EN", town: "Bournemouth" },
        { long: -0.1357, lat: 50.8284, country: "EN", town: "Brighton" },
        { long: -2.5879, lat: 51.4545, country: "EN", town: "Bristol" },
        { long: 0.4685, lat: 51.7356, country: "EN", town: "Chelmsford" },
        { long: -2.8909, lat: 53.1934, country: "EN", town: "Chester" },
        { long: -3.5338, lat: 50.7184, country: "EN", town: "Exeter" },
        { long: -0.5676, lat: 51.2362, country: "EN", town: "Guildford" },
        { long: -0.3367, lat: 53.7676, country: "EN", town: "Hull" },
        { long: -1.5486, lat: 53.8008, country: "EN", town: "Leeds" },
        { long: -1.1339, lat: 52.6369, country: "EN", town: "Leicester" },
        { long: -2.9785, lat: 53.4084, country: "EN", town: "Liverpool" },
        { long: -0.1276, lat: 51.5074, country: "EN", town: "London" },
        { long: -2.2426, lat: 53.4808, country: "EN", town: "Manchester" },
        { long: -0.7558, lat: 52.0406, country: "EN", town: "Milton Keynes" },
        { long: -1.6174, lat: 54.9783, country: "EN", town: "Newcastle" },
        { long: 1.2993, lat: 52.6309, country: "EN", town: "Norwich" },
        { long: -1.151, lat: 52.9548, country: "EN", town: "Nottingham" },
        { long: -4.1427, lat: 50.3755, country: "EN", town: "Plymouth" },
        { long: -0.9781, lat: 51.4543, country: "EN", town: "Reading" },
        { long: -1.4701, lat: 53.3811, country: "EN", town: "Sheffield" },
        { long: -1.4044, lat: 50.9097, country: "EN", town: "Southampton" },
        { long: -5.9301, lat: 54.5973, country: "NI", town: "Belfast" },
        { long: -6.2603, lat: 53.3498, country: "IE", town: "Dublin" },
        { long: -8.4863, lat: 51.8985, country: "IE", town: "Cork" },
        { long: -9.0489, lat: 53.2707, country: "IE", town: "Galway" },
        { long: -8.4711, lat: 54.2766, country: "IE", town: "Sligo" },
        { long: -4.2518, lat: 55.8642, country: "SC", town: "Glasgow" },
        { long: -3.1883, lat: 55.9533, country: "SC", town: "Edinburgh" },
        { long: -4.2247, lat: 57.4778, country: "SC", town: "Inverness" },
        { long: -2.0943, lat: 57.1497, country: "SC", town: "Aberdeen" },
        { long: -2.9707, lat: 56.462, country: "SC", town: "Dundee" },
        { long: -3.1791, lat: 51.4816, country: "WA", town: "Cardiff" },
        { long: -3.9449, lat: 51.6214, country: "WA", town: "Swansea" }
      ],
      center: [-1.17432, 52.355518],
      cityCentre: null,
      city_name: '',
      city_api: '',
      showRow: null,
      products: [],
      url:'',
      ready:false,
      courseLocations: [], // venues that actually have upcoming in-person courses
      nearbyLimit: 2        // how many nearby suggestions to show
    }
  },
  async fetch() {
    this.products = await productData.find((o) => {
      return o?.classRoomCourse?.days.toString() === '2'
    })
  },
  head() {
    if(this.ready && this.structuredDataEvent.itemListElement.length > 0){
        return {
            script: [
              // { type: 'application/ld+json', json: this.structuredDataCourse },
              { type: 'application/ld+json', json: this.structuredDataEvent }]
        }
      }
    },
  computed: {
    ...mapGetters({
      // region: 'user/region',
      detectedRegion: 'geolocation/region',
      userRegion: 'user/region',
      priceLabel: 'cart/getPriceLabel',
      activeModal : 'pages/getActiveModal',
      // page: 'pages/getPage',
    }),
    // Coords of the city being viewed, used as the "from" point for distance sorting.
    // Falls back to the hardcoded city list; returns null if we can't place it.
    originCoords(){
      const name = (this.city_name || '').toLowerCase()
      const match = this.cities.filter((c) => c.town && c.town.toLowerCase() === name)
      return match.length ? match[0] : null
    },
    nearbyArray(){
      // Suggestions come entirely from the cities we actually have courses in
      // (the query result), showing the closest few to the current city.
      // The old manual `nearby` prop list is deliberately ignored — those values
      // are stale now that most locations no longer run physical courses.
      if (this.courseLocations.length === 0) return []

      const origin = this.originCoords
      const seen = {}
      const list = this.courseLocations
        .map((loc) => this.cleanLocation(loc))
        .filter((loc) => {
          // one suggestion per town, and never suggest the town we're already on
          if (!loc || !loc.town) return false
          const key = loc.town.toLowerCase()
          if (seen[key] || key === (this.city_name || '').toLowerCase()) return false
          seen[key] = true
          return true
        })

      // If we know where the user is, rank by distance; otherwise show as-is.
      if (origin) {
        list.forEach((loc) => {
          loc.distance = this.distanceKm(origin.lat, origin.long, loc.lat, loc.long)
        })
        list.sort((a, b) => a.distance - b.distance)
      }

      return list.slice(0, this.nearbyLimit)
    },
    // Points to plot on the nearby map — the same closest locations shown in the list.
    mapPoints(){
      return this.nearbyArray
    },
    classesToShow() {
      return this.classrooms.filter((classroom, index) => index < this.noOfRows)
    },
    region(){
      return this.userRegion === 'default' ? this.detectedRegion : this.userRegion
    },
    regionToShow() {
      return this.$options.filters.regionToShow(this.region);
    },
    // FOR SCHEMA
    productsList() {
      // get products for sale and all classrooms for each
      const twoDayProducts = []
      const threeDayProducts = []
      this.classrooms.forEach((classroom) => {
        classroom.products.forEach((product) => {
          product.classrooms = []
          if(product.prices.length > 0 && product.id !== 2) {
            // 2 day classrooms
            if(classroom.length === 4 || classroom.length === '4') {
            // avoid duplicate products
            if(!twoDayProducts.some(el => el.id === product.id)){
              // add classroom (instance to product)
              this.classrooms.forEach((classroom) => {
                if(classroom.length === 4 || classroom.length === '4') {
                  product.classrooms.push(classroom)
                }
              })
              twoDayProducts.push(product)
            }
          }
          // 3 day classrooms  // avoid duplicate products
          else if(!threeDayProducts.some(el => el.id === product.id)) {
             // add classroom (instance to product)
            this.classrooms.forEach((classroom) => {
              if(classroom.length === 5 || classroom.length === '5') {
                product.classrooms.push(classroom)
              }
            })
            threeDayProducts.push(product)
          }
          }
        })
      })
      // return list of valid products with classroom instances
        return twoDayProducts.concat(threeDayProducts)
    },
    currency(){
          const currency = this.$nuxt.$options.filters.currencyCodeFromLabel()
          return currency
        },
    priceData() {
      const priceDataArray = []
      this.productsList.forEach((product) => {
        const priceD = this.$options.filters.priceData(product)
        priceDataArray.push(priceD)
      })
      return priceDataArray
    },
    prices() {
      const prices = []
      this.priceData.forEach((priceData) => {
        const price = this.$nuxt.$options.filters.priceFromLabelNumber(priceData.pricesDiscounted)
        prices.push(price)
      })
      return prices
    },
    //  products(){return productData}
    // CURRENCY
    // LIST OF COURSE INSTANCES
    // courseInstances() {
    //   // don't have one big list of instances needs to be per classroom, put on classroom object or call a function with classroom as argument
    //   // const instances = []
    //   this.productsList.forEach((product, index) => {
    //     const count = index
    //     product.instances = []
    //     let mode;
    //     if (product.type === "combined course") {
    //       mode = "Blended"
    //     }
    //     else if (product.type === "classroom course") {
    //       mode = "Onsite"
    //     }
    //     else {
    //       mode = "Online"
    //     }
    //     product.classrooms.forEach((classroom) => {
    //       const dateText = this.getDateText(classroom)
    //       product.instances.push({
    //         "@type": "CourseInstance",
    //         "name": `${this.getLocality(classroom)} TEFL Course: ${dateText}`,
    //         "courseMode": mode,
    //         "courseWorkload": "PT"+product.data[0].course.hours.toString()+"H",
    //         "startDate":classroom.startDate,
    //         "endDate":classroom.endDate,
    //         "location": {
    //           "@type": "Place",
    //           "name": classroom.venue.name,
    //           "address": {
    //           "@type": "PostalAddress",
    //           "streetAddress": classroom.venue.line1,
    //           "addressLocality": this.getLocality(classroom),
    //           "postalCode":classroom.venue.postcode,
    //           "addressCountry":classroom.venue.country
    //           }
    //         },
    //         "offers": {
    //           "@type": "Offer",
    //           "category": "Paid",
    //           "price": this.prices[count].toString(),
    //           "priceCurrency": this.currency,
    //           "availability": "https://schema.org//LimitedAvailability",
    //         },
    //       })
    //     })
    //   })
    //   return 'ready'
    // },
    // itemList() {
    //   const itemList = []
    //   this.productsList.forEach((product, index) => {
    //     itemList.push({
    //       "position":index+1,
    //       "@type":"Course",
    //       "url":"https://www.tefl.org"+product.data[0].page.en.uri,
    //       "name":product.name,
    //       "image":product.data[0].page.en.thumbnail,
    //       "description": product.description,
    //       "provider": {
    //         "@type": "Organization",
    //         "name": "The TEFL Org",
    //         "url": "https://www.tefl.org/",
    //         },
    //         "offers": {
    //           "@type": "Offer",
    //           "category": "Paid",
    //           "price": this.prices[index].toString(),
    //           "priceCurrency": this.currency,
    //           "availability": "https://schema.org//LimitedAvailability",
    //           // "validFrom": "2024-01-15",
    //           // "validThrough": "2024-02-15"
    //         },
    //       "hasCourseInstance": product.instances
    //     })
    //   })
    //   return itemList
    // },
    // structuredDataCourse() {
    //   return {
    //   "@context":"https://schema.org/",
    //   "@type": "ItemList",
    //   "itemListElement": this.itemList,
    //   "name":`TEFL Courses in ${this.$nuxt.$options.filters.capitalise(this.city_name)}`,
    //   }
    // },
    structuredDataEvent() {
      const itemList = []
      this.productsList.forEach((product, index) => {
      product.classrooms.forEach((classroom) => {
      const dateText = this.getDateText(classroom)
        itemList.push({
          "@type":"Event",
          "name": `${this.getLocality(classroom)} TEFL Course: ${dateText}`,
          "url": `https://www.tefl.org${this.url}`,
          "image":this.$store.state.pages.page.thumbnail,
          "startDate": classroom.startDate,
          "endDate": classroom.endDate,
          "eventAttendanceMode":'https://schema.org/OfflineEventAttendanceMode',
          "eventStatus": "https://schema.org/EventScheduled",
          "description":`TEFL courses in ${this.getLocality(classroom)}  with The TEFL Org. The ${this.getLocality(classroom)} TEFL course gives you all the essential tools you need to be able to plan and prepare your own TEFL classes, no matter what size of class you may face. Our courses have been designed by highly qualified TEFL industry professionals with years of experience to ensure courses of the highest quality and up-to-date training.`,
          "offers": {
              "@type": "Offer",
              "category": "Paid",
              "name":product.name,
              "price": this.prices[index].toString(),
              "priceCurrency": this.currency,
              "availability": "https://schema.org/LimitedAvailability",
              "url": "https://www.tefl.org"+product.data[0]?.page[this.regionToShow]?.uri,
              "validFrom": classroom.dateCreated,
              // "validThrough": "2024-02-15"
            },
          "location": {
            "@type": "Place",
            "name": classroom.venue.name,
            "address": {
            "@type": "PostalAddress",
            "streetAddress": classroom.venue.line1,
            "addressLocality": this.getLocality(classroom),
            "postalCode":classroom.venue.postcode,
            "addressCountry":classroom.venue.country
            }
          },
          "organizer": {
            "@type": "Organization",
            "name": "The TEFL Org",
            "url": "https://www.tefl.org/",
            "sameAs": "https://www.tefl.org/",
            },
          "performer": {
            "@type":"Organization",
            "name": "The TEFL Org",
          }
        })
      })
      })

      return {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "itemListElement":itemList,
        "name": `TEFL Courses in ${this.$nuxt.$options.filters.capitalise(this.city_name)}`,
      }
    }
  },
  async mounted() {
    const locs = []
    try {
      // console.log('PAGE DATA',this.page)
      this.city_name = await this.$store.state.pages.page.geolocationCity || this.$store.state.pages.page.slug || 'London'
      this.city_api = 'Online'
      this.url = await this.$store.state.pages.page.uri
      // Get all of the classrooms for this location
      const results = await axios.get(
        `${process.env.DATA_URL}/classroom/city/${this.city_api}?productPriceLabel=${this.priceLabel}`
      )

      // WE NEED TO FILTER OUT 5 DAY COURSES FROM OUR RESULTS
      // eslint-disable-next-line dot-notation
      const newResults = results.data.filter(r => r['length'] !== '5');

      this.classrooms = newResults.map((classroom) => {
        classroom.places = classroom.maxAttendees - classroom.numAttendees
        classroom.availability = this.getAvailable(classroom.places)
        classroom.products=classroom.products.filter((p) => p.id!==9 && p.id!==10177 && p.id!==11103 && p.id!==152 && p.id!==10173 && p.id!==151 && p.id!==10169)
        locs.push(classroom.venueId)
        for (const product of classroom.products) {
          // console.log('PRODUCTDATA',product)
          product.data = productData.filter(o => o.id===product.id)
          // console.log(product.test)
          if (product.prices.length > 0)
            product.priceData = this.$options.filters.priceData({ ...product })
            product.onSale = product.priceData?.saleType !== 'none'
          }
        // console.log('CLASSROOM',classroom)
        return classroom
      })

      // Pull the real towns that have upcoming in-person courses so we can
      // work out the nearest alternatives automatically.
      try {
        const locationResults = await axios.get(`${process.env.DATA_URL}/classroom/upcoming`)
        this.courseLocations = locationResults.data || []
      } catch (locErr) {
        console.log('Could not load course locations', locErr)
      }

      // Centre the map on the current city if we can place it, else keep the default.
      const origin = this.originCoords
      if (origin) {
        this.center = [origin.long, origin.lat]
      }

    } catch (error) {
      console.log(error)
    }
    this.ready = true
  },
  methods: {
      ...mapActions({
          updateActiveModal: 'pages/updateActiveModal', // map `this.add()` to `this.$store.commit('increment')`
      }),
      countryToRegion(country){
        const c = {
          'EN': "england",
          'IE': "ireland",
          'SC': "scotland",
          'WA': "wales",
          'NI': "northern-ireland",
        }
        return c[country]
      },
      // Clean up the messy country/town values in the venue data so the location
      // links resolve. Coordinates are trusted as-is — they're accurate.
      cleanLocation(loc){
        const countryMap = {
          EN: 'EN', ENGLAND: 'EN',
          SC: 'SC', SS: 'SC', SCOTLAND: 'SC',
          WA: 'WA', WALES: 'WA',
          NI: 'NI', 'NORTHERN IRELAND': 'NI',
          IE: 'IE', IRELAND: 'IE'
        }
        // Venue-specific town fixes -> the slug the location page actually uses.
        const townMap = {
          'london-paddington': 'London'
        }
        const rawCountry = (loc.country || '').toUpperCase()
        const rawTown = (loc.town || '').trim()
        return Object.assign({}, loc, {
          country: countryMap[rawCountry] || loc.country,
          town: townMap[rawTown.toLowerCase()] || rawTown
        })
      },
      // Great-circle distance between two points in km (Haversine).
      distanceKm(lat1, lon1, lat2, lon2){
        const toRad = (deg) => deg * Math.PI / 180
        const R = 6371
        const dLat = toRad(lat2 - lat1)
        const dLon = toRad(lon2 - lon1)
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
          Math.sin(dLon / 2) * Math.sin(dLon / 2)
        return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      },
      loadMore() {
        this.noOfRows = this.noOfRows + 5
      },
      toggleViews(view){
        this.toggleView = view
      },
      updateModalFunc(name){
          // const newId = this.$nuxt.$options.filters.convertModal(id)
          const hours = name.substring(0,3).replaceAll('-', '');
          const id = hours+'vincludedtable'
          this.updateActiveModal(id)
          console.log('Active ID: ',id)
      },
      updateModal(id){
          // const newId = this.$nuxt.$options.filters.convertModal(id)
          this.updateActiveModal(id)
          console.log('Active Modal: ',this.activeModal)
      },
      hideModal(){
          this.updateActiveModal(null)
          console.log('Active Modal: ',this.activeModal)
      },
    showOption(index) {
      console.log(index)
      if(index === this.showRow){
        this.showRow = null
      } else {
        this.showRow = index
      }
      this.$nextTick(() => {
        const element = document.getElementById('classvirtual'+index)
        element.scrollIntoView({
          behavior: 'smooth',
        })
      })
    },
    getLocality(classroom) {
      return classroom.venue.city ? classroom.venue.city : classroom.venue.town
    },
    getAvailable(places) {
      if (places <= 1) return 'low'
      if (places >= 2 && places <= 8) return 'medium'
      return 'good'
    },
    getDateText(classroom) {
      let dateText
          // Get the two digits representing the DAY
          const startSlug = classroom.startDate.slice(-2)
          const endSlug = classroom.endDate.slice(-2)

          // Get the two digits representing the MONTH
          const startMonthSlug = classroom.startDate.slice(5, 2)
          const endMonthSlug = classroom.startDate.slice(5, 2);

          // Get the name of the start month
          const date = new Date(classroom.startDate)
          const month = date.toLocaleString('default', { month: 'long' });

          // If it starts and ends in the same month
          if (startMonthSlug === endMonthSlug) {
            dateText  = startSlug + '-' + endSlug + ' ' + month
            // console.log('month: ', dateText)
        } else {
          const dateTwo = new Date(classroom.endDate)
          const monthTwo = dateTwo.toLocaleString('default', { month: 'short' });
          dateText  = startSlug + ' ' + monthTwo  + '-' + endSlug + ' ' + month

        }
      return dateText;
    },
    optionText(classes){
      console.log('CLASSES',classes)
      let timeString = ''
      const startTime = this.$options.filters.convertDateSimple(classes.startDate+' '+classes.startTime, 'ha')
      const endTime = this.$options.filters.convertDateSimple(classes.endDate+' '+classes.endTime, 'ha z')
      // timeString += classes.sessions.length === 2 ? 'EXPRESS | ' : ''
      timeString += '<strong>Date: </strong>' + this.$options.filters.convertDateSimple(classes.startDate+' '+classes.startTime,'Do') + ' ' + this.$options.filters.convertDateSimple(classes.startDate+' '+classes.startTime,'MMM') + ' - '
      timeString += this.$options.filters.convertDateSimple(classes.endDate+' '+classes.startTime,'Do') + ' ' + this.$options.filters.convertDateSimple(classes.endDate+' '+classes.startTime,'MMM') + '<br>'
      timeString += '<strong>Time: </strong>' + startTime + ' - ' + endTime
      return timeString
    }
  },
}
